// extracted by mini-css-extract-plugin
export var NoResultTextContainer = "NoResultText-module--NoResultTextContainer--ZG5q3";